<script>
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import Loader from "@/components/widgets/loader";
import exportToExcel from "../../../helpers/export_to_excel";

import { required, minLength, maxLength } from "vuelidate/lib/validators";

import html2canvas from "html2canvas";
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: { AlertError, Loader, VueQRCodeComponent },
  data() {
    return {
      //Page errors.
      errors: [],
      showLoader: false,
      printBtnLoader: false,
      showAlert: false,

      qrCodeContent: "",
      beneficiary: "",
      beneficiaryCode: "",
      items: [],

      // datatable
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      pageOptions: [
        10,
        25,
        50,
        100,
        1000,
        { value: Number.MAX_SAFE_INTEGER, text: "عرض الكل" },
      ],
      filter: "",
      filterOn: [],
      sortBy: "index",
      sortDesc: false,
      fields: [
        {
          // A virtual column that doesn't exist in items
          label: "التسلسل",
          key: "index",
          sortable: true,
          visible: true,
        },
        {
          label: "الاسم الرباعي",
          key: "fullNamePerson",
          sortable: true,
          visible: true,
        },
        {
          label: "صلة القرابة",
          key: "kinship",
          sortable: true,
          visible: true,
        },
        {
          label: "الجنس",
          key: "gender",
          sortable: true,
          visible: true,
        },
        {
          label: "اسم الام",
          key: "motherName",
          sortable: true,
          visible: true,
        },
        {
          label: "الرقم التسلسلي",
          key: "personCode",
          sortable: true,
          visible: true,
        },
        {
          label: "المحافظة",
          key: "currentAccommodation",
          sortable: true,
          visible: true,
        },
        {
          label: "رقم الهاتف",
          key: "phoneNumberOne",
          sortable: true,
          visible: true,
        },
        {
          label: "الاجراءات",
          key: "settings",
          class: "col-setting-services-print-id",
          sortable: true,
          visible: this.$store.getters["auth/getUser"].hasAnyPermission([
            "print_beneficiary_card",
          ]),
        },
      ],
      submit: false,
      notFoundBeneficiary: false,
      isBusy: false,
    };
  },
  validations: {
    beneficiaryCode: { required, minLength: minLength(10), maxLength: maxLength(10) },
  },
  computed: {
    ...mapGetters("mubinBeneficiary", ["getBeneficiaries"]),
    start() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    end() {
      return Math.min(this.currentPage * this.perPage, this.totalItems);
    },
    getBeneficiaryName() {
      return (
        this.beneficiary.firstName +
        " " +
        this.beneficiary.secondName +
        " " +
        this.beneficiary.thirdName
      );
    },
    getBeneficiaryBirthDate() {
      return this.beneficiary.BOD;
    },
    getBeneficiaryCode() {
      return this.beneficiary.personCode;
    },
    getBeneficiaryRelation() {
      let relation = [
        "والد/ة",
        "زوج/ة",
        "إبن/بنت",
        "أخ/أخت",
        "جد/ة",
        "عم/ة",
        "خال/ة",
        "الزوجة الثانية",
        "الزوجة الثالثة",
        "الزوجة الرابعة",
      ];
      let beneficiaryMail_MartyrMail_Relation = [
        "مضحي بإبن",
        "مضحي بزوجة",
        "مضحي بأب",
        "مضحي بأخ",
        "مضحي بحفيد",
        "مضحي بإبن أخ",
        "مضحي بإبن أخت",
        "مضحي بزوجة",
        "مضحي بزوجة",
        "مضحي بزوجة",
      ];
      let beneficiaryFemail_MartyrMail_Relation = [
        "مضحية بإبن",
        "مضحية بزوج",
        "مضحية بأب",
        "مضحية بأخ",
        "مضحية بحفيد",
        "مضحية بإبن أخ",
        "مضحية بإبن أخت",
        "مضحية بزوج",
        "مضحية بزوج",
        "مضحية بزوج",
      ];
      let beneficiaryMail_MartyrFemail_Relation = [
        "مضحي ببنت",
        "مضحي بزوجة",
        "مضحي بأم",
        "مضحي بأخت",
        "مضحي بحفيدة",
        "مضحي ببنت أخ",
        "مضحي ببنت أخت",
        "مضحي بزوجة",
        "مضحي بزوجة",
        "مضحي بزوجة",
      ];
      let beneficiaryFemail_MartyrFemail_Relation = [
        "مضحية ببنت",
        "مضحية بزوج",
        "مضحية بأم",
        "مضحية بأخت",
        "مضحية بحفيدة",
        "مضحية ببنت أخ",
        "مضحية ببنت أخت",
        "مضحية بزوج",
        "مضحية بزوج",
        "مضحية بزوج",
      ];

      let relationIndex = relation.findIndex((r) => r == this.beneficiary.kinship);

      if (relationIndex >= 0) {
        //المستفيد ذكر
        if (this.beneficiary.gender == "ذكر") {
          if (this.beneficiary.sacrificer.gender == "ذكر") {
            return beneficiaryMail_MartyrMail_Relation[relationIndex];
          } else if (this.beneficiary.sacrificer.gender == "أنثى") {
            return beneficiaryMail_MartyrFemail_Relation[relationIndex];
          }
        }

        //المستفيد إنثى
        if (this.beneficiary.gender == "أنثى") {
          if (this.beneficiary.sacrificer.gender == "ذكر") {
            return beneficiaryFemail_MartyrMail_Relation[relationIndex];
          } else if (this.beneficiary.sacrificer.gender == "أنثى") {
            return beneficiaryFemail_MartyrFemail_Relation[relationIndex];
          }
        }
      }
      return "";
    },
    getBeneficiaryQrCode() {
      return "https://emtenan.org/qr-info/" + this.getBeneficiaryCode;
    },
  },
  methods: {
    codeform() {
      this.submit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$error) return;
      this.getBeneficiaryByCode();
    },
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    ...mapActions("mubinBeneficiary", ["getAll", "get"]),
    // datatable
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchAll() {
      this.isBusy = true;

      this.getAll({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
      })
        .then((response) => {
          this.totalItems = response.data.COUNT_OF_BENEFICIARY;
          
          let i = 1;
          this.items = this.getBeneficiaries.map((x) => {
            x.index = i++;
            return x;
          });
          this.isBusy = false;
        })
        .catch((error) => {
          this.handleError(error);
          this.isBusy = false;
        });
    },
    getBeneficiaryByCode() {
      this.printBtnLoader = true;
      this.notFoundBeneficiary = false;

      this.get(this.beneficiaryCode)
        .then((response) => {
          let beneficiary = response.data;

          if (beneficiary.category != "مستفيد") {
            throw new Error("Code : 500");
          }

          this.btnPrintCard(beneficiary);
          this.printBtnLoader = false;
        })
        .catch(() => {
          this.notFoundBeneficiary = true;
          this.printBtnLoader = false;
        });
    },
    exportTable() {
      exportToExcel(this.visibleFields(), this.items, "بيانات المستفيدين بواسطة مبين");
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    btnPrintCard(beneficiary) {
      this.beneficiary = beneficiary;
      this.qrCodeContent = this.getBeneficiaryQrCode;
      this.showModal();
    },
    reload() {
      let i = 1;
      this.items = this.getBeneficiaries.map((x) => {
        x.index = i++;
        return x;
      });
    },
    // print card
    async printCard() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(
        el,
        {
          width: el.clientWidth,
          height: el.clientHeight,
          scale: 10,
        },
        options
      );
      const link = document.createElement("a");
      link.setAttribute("download", this.getBeneficiaryName + "front.png");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream")
      );
      link.click();

      const el2 = this.$refs.printcontent2;
      const options2 = { type: "dataURL" };
      const printCanvas2 = await html2canvas(
        el2,
        {
          width: el2.clientWidth,
          height: el2.clientHeight,
          scale: 10,
        },
        options2
      );
      const link2 = document.createElement("a");
      link2.setAttribute("download", this.getBeneficiaryName + "back.png");
      link2.setAttribute(
        "href",
        printCanvas2.toDataURL("image/png").replace("image/png", "image/octet-stream")
      );
      link2.click();
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchAll();
      },
    },
    perPage: {
      handler: function () {
        this.fetchAll();
      },
    },
  },
  created() {
    this.fetchAll();
  },
};
</script>

<template>
  <div>
    <!-- start modal-print-card -->
    <b-modal
      id="modal-print-card"
      ref="my-modal"
      size="lg"
      centered
      title-class="font-18"
      hide-footer
    >
      <template #modal-title>
        <b-button @click="printCard" class="btn-sm" variant="info">حفظ الهوية</b-button>
      </template>

      <div class="text-center">
        <h4 class="mb-3">طباعة هوية امتنان</h4>
      </div>

      <div class="row con-card-imtenan mb-4">
        <div class="col-md-6 mb-1">
          <div class="card-imtenan-front" ref="printcontent">
            <img
              src="@/assets/images/card/card-emtenan-1.jpg"
              class="front-image"
              alt="card-emtenan"
            />
            <div class="title">
              <p class="p1">هيأة الحشد الشعبي</p>
              <p class="p2">هوية امتنان</p>
            </div>
            <div class="text">
              <p class="full-name">{{ getBeneficiaryName }}</p>
              <p class="no">
                رقم التسلسل : <span>{{ getBeneficiaryCode }}</span>
              </p>
              <p class="relative-relation">
                صـلة القـرابـة : <span>{{ getBeneficiaryRelation }}</span>
              </p>
              <p class="birth-date">
                تاريخ الميلاد : <span>{{ getBeneficiaryBirthDate }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-1">
          <div class="card-imtenan-back" ref="printcontent2">
            <img
              src="@/assets/images/card/card-emtenan-2.jpg"
              class="back-image"
              alt="card-emtenan"
            />
            <div class="title">
              <p>تذكر دوماً</p>
            </div>
            <div class="text">
              <p class="p1">- ان حملك لهوية امتنان يعني انك من أمة الشهداء.</p>
              <p class="p2">- لا تعتبر هذه الهوية وثيقة رسمية .</p>
              <p class="p3">- في حال فقدان الهوية الاتصال</p>
              <p class="p4">بالرقم : <span>07864969222</span></p>
            </div>
            <VueQRCodeComponent
              class="qr-code-card"
              :text="qrCodeContent"
            ></VueQRCodeComponent>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- end modal-print-card -->

    <Loader :loading="showLoader">
      <div class="row mt-3">
        <div class="col-12">
          <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

          <div class="row">
            <div class="col-md-12">
              <div id="tickets-table_filter" class="dataTables_filter">
                <form action="#" @submit.prevent="codeform">
                  <label class="align-items-center">طباعة الهوية :</label>
                  <b-form-input
                    type="number"
                    v-model="beneficiaryCode"
                    name="beneficiaryCode"
                    placeholder="ادخل الرقم التسلسي..."
                    class="form-control form-control-md mb-2"
                    :class="{ 'is-invalid': submit && $v.beneficiaryCode.$error }"
                    :disabled="printBtnLoader"
                  ></b-form-input>
                  <div
                    v-if="submit && $v.beneficiaryCode.$error"
                    class="invalid-feedback mb-2"
                  >
                    <span v-if="!$v.beneficiaryCode.required"
                      >يجب ادخال الرقم التسلسلي اولا</span
                    >
                    <span v-if="!$v.beneficiaryCode.minLength"
                      >يجب ان يتكون الرقم التسلسلي من 10 ارقام على الاقل</span
                    >
                    <span v-if="!$v.beneficiaryCode.maxLength"
                      >يجب ان يتكون الرقم التسلسلي من 10 ارقام على الاكثر</span
                    >
                  </div>
                  <div>
                    <p class="text-center color-red" v-if="notFoundBeneficiary">
                      الرقم التسلسلي غير موجود
                    </p>
                  </div>
                  <b-button
                    class="btn-md"
                    type="submit"
                    variant="primary"
                    :disabled="printBtnLoader"
                    style="width: 100%"
                    >عرض الهوية</b-button
                  >
                </form>
              </div>
              <hr />
            </div>
          </div>

          <!-- Header Table -->
          <div class="row mt-1">
            <!-- table_length -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  عرض&nbsp;:&nbsp;
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  &nbsp;مدخلات
                </label>
              </div>
            </div>

            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center">
                  بحث&nbsp;:&nbsp;
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="بحث..."
                    class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
                <b-button class="btn-sm mx-2" variant="primary" @click="exportTable"
                  >Excel</b-button
                >
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              show-empty
              hover
              :items="items"
              :fields="visibleFields()"
              responsive="md"
              :per-page="0"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              :busy="isBusy"
            >
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <br />
                  <strong>تحميل البيانات...</strong>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(index)="data">
                {{ data.index + 1 + (currentPage - 1) * perPage }}
              </template>

              <!-- A custom formatted column Sutting -->
              <template v-slot:cell(settings)="data">
                <div class="button-items">
                  <b-button class="btn-sm" variant="info" @click="btnPrintCard(data.item)"
                    >طباعة هوية</b-button
                  >
                </div>
              </template>
            </b-table>
          </div>

          <!-- Footer Table -->
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
              <div class="dataTables_paginate paging_simple_numbers float-start">
                <p>عرض من {{ start }} الى {{ end }} من مجموع {{ totalItems }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
